import { Link, Outlet } from "react-router-dom";
import { KeyRound, LogOut } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { LogoMark } from "../Logo";

export const AdminShell = () => {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen bg-[#F9FAFC] font-body text-[#0B192C]">
      <header className="bg-[#0B192C] text-[#F4EDE3]">
        <div className="mx-auto flex max-w-5xl items-center justify-between gap-4 px-5 py-4 md:px-8">
          <Link to="/admin" data-testid="admin-home-link" className="flex items-center gap-3">
            <LogoMark className="h-8 w-8" />
            <span className="font-display text-lg">Pitch editor</span>
          </Link>
          <div className="flex items-center gap-2 sm:gap-4">
            <span className="hidden text-sm text-slate-300 md:inline">{user?.email}</span>
            <Link to="/admin/password" data-testid="admin-password-link" className="flex items-center gap-2 rounded-full px-3 py-2 text-sm transition-colors duration-200 hover:bg-[#F4EDE3]/10">
              <KeyRound className="h-4 w-4" /> <span className="hidden sm:inline">Password</span>
            </Link>
            <button data-testid="admin-logout-btn" onClick={logout} className="flex items-center gap-2 rounded-full border border-[#F4EDE3]/30 px-4 py-2 text-sm transition-colors duration-200 hover:bg-[#F4EDE3]/10">
              <LogOut className="h-4 w-4" /> Log out
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-5xl px-5 py-10 md:px-8 md:py-14">
        <Outlet />
      </main>
    </div>
  );
};
